import React from "react";
import { ShieldAlert } from "lucide-react";
import { fillWarning } from "../../lib/suppliers";

export function UnapprovedSupplierDialog({ pending, settings, category, onConfirm, onChange }) {
  if (!pending) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-start justify-center p-4 pt-16 bg-slate-900/60 backdrop-blur-sm" data-testid="unapproved-supplier-dialog">
      <div className="bg-white max-w-md w-full shadow-2xl border border-slate-200 rounded-lg overflow-hidden">
        <div className="flex items-start gap-3 px-6 py-4 border-b border-slate-200 bg-red-50">
          <ShieldAlert size={22} className="text-red-600 mt-0.5 shrink-0" />
          <div>
            <h2 className="text-base font-semibold text-slate-900" data-testid="unapproved-supplier-title">{settings?.warning_title || "Supplier not approved"}</h2>
            <div className="text-xs text-slate-500 mt-0.5">{pending.section === "access_hire" ? "Access Hire" : "Parts & Materials"} · <span className="font-semibold text-slate-700">{pending.name}</span></div>
          </div>
        </div>
        <p className="px-6 py-4 text-sm text-slate-700 whitespace-pre-line" data-testid="unapproved-supplier-message">
          {fillWarning(settings?.warning_message, pending.name, category)}
        </p>
        <div className="px-6 py-4 bg-slate-50 border-t border-slate-200 flex justify-end gap-2">
          <button onClick={onChange} data-testid="unapproved-supplier-change"
            className="px-4 h-10 rounded border border-slate-300 text-sm font-semibold text-slate-700 hover:bg-white transition-colors">
            Change supplier
          </button>
          <button onClick={onConfirm} data-testid="unapproved-supplier-confirm"
            className="px-4 h-10 rounded bg-red-600 text-white text-sm font-semibold hover:bg-red-700 transition-colors">
            Confirm for use
          </button>
        </div>
      </div>
    </div>
  );
}

export function UnapprovedTag({ rec, testid }) {
  if (!rec) return null;
  const when = rec.confirmed_at ? new Date(rec.confirmed_at).toLocaleString("en-GB", { dateStyle: "short", timeStyle: "short" }) : "";
  return (
    <span data-testid={testid} title={`Confirmed by ${rec.confirmed_by || "?"}${when ? " · " + when : ""}`}
      className="inline-flex items-center gap-1 mt-0.5 px-1.5 py-0.5 rounded bg-red-50 border border-red-200 text-[10px] font-semibold uppercase tracking-wider text-red-700 whitespace-nowrap">
      <ShieldAlert size={10} /> Unapproved
    </span>
  );
}
